
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findTournamentStartList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournament_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"round_index"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"switchURL"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"switchTournaments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findTournamentStartList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tournament_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournament_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"round_index"},"value":{"kind":"Variable","name":{"kind":"Name","value":"round_index"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"switchURL"},"value":{"kind":"Variable","name":{"kind":"Name","value":"switchURL"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"switchTournaments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"switchTournaments"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentTicker"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tickerText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"zoom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"associationName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxPages"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showDuration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logoImg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"footerImg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"livescoringNextLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nextTournamentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nextTournamentRoundIndex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tournamentName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tournamentPlayForm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tournamentScoringMode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lang"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tournamentStartList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flighId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startTee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startTee1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"players"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clubName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hcp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":739}};
    doc.loc.source = {"body":"query findTournamentStartList($tournament_id:Int!,$round_index:Int!,$switchURL:Int,$switchTournaments:Int) {\n  findTournamentStartList(input:{tournament_id:$tournament_id, round_index:$round_index,switchURL:$switchURL,switchTournaments:$switchTournaments}) {\n    currentTicker {\n      tickerText\n      id\n    }\n    zoom\n    associationName\n    lastUpdate\n    maxPages\n    showDuration\n    logoImg\n    footerImg\n    livescoringNextLink\n    nextTournamentId\n    nextTournamentRoundIndex\n    tournamentName\n    tournamentPlayForm\n    tournamentScoringMode\n    lang\n    tournamentStartList {\n      flighId\n      startTee\n      startTee1\n      startTime\n      players {\n        name\n        clubName\n        hcp\n        flag\n      }\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["findTournamentStartList"] = oneQuery(doc, "findTournamentStartList");
        
